/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingModule_item = {
    readonly storyTellingModule: {
        readonly tabs: ReadonlyArray<{
            readonly tabTitle: string;
            readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpRespStorytellingModule_item";
};
export type PdpRespStorytellingModule_item$data = PdpRespStorytellingModule_item;
export type PdpRespStorytellingModule_item$key = {
    readonly " $data"?: PdpRespStorytellingModule_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingModule_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '71bc65142968f61ab2f6413aa011dd54';
export default node;
